const locale = {
  TITLE_PAGE_401: 'Sin autorización',
  SUBTITLE_PAGE_401: '¡Ups! No tienes permiso para ver esta página.',
  HOME_BUTTON_PAGE_401: 'Volver al inicio',
};

export default locale;
